/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Search_No_Results_DescInputs */

const en_directory_search_no_results_desc = /** @type {(inputs: Directory_Search_No_Results_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try a different keyword or browse categories.`)
};

const zh_directory_search_no_results_desc = /** @type {(inputs: Directory_Search_No_Results_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`换个关键词试试，或浏览分类。`)
};

/**
* | output |
* | --- |
* | "Try a different keyword or browse categories." |
*
* @param {Directory_Search_No_Results_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_search_no_results_desc = /** @type {((inputs?: Directory_Search_No_Results_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Search_No_Results_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_search_no_results_desc(inputs)
	return zh_directory_search_no_results_desc(inputs)
});
export { directory_search_no_results_desc as "directory.search.no_results_desc" }